module.exports = __webpack_public_path__ + "images/3d459348e78563a4168da3c53c0fdc3a.svg";